import React, {Component} from 'react';
import "./video_play_button.scss";

/**
 * The Luiss' video player button properties
 */
interface VideoPlayButtonProps {

    // callback for when the user click on the button
    startVideo(): void;
}

/**
 * A responsive and stateless component which show the Luiss' video player button
 *
 * When the use click on it, it calls the startVideo property function
 */
class VideoPlayButton extends Component<VideoPlayButtonProps> {

    render() {
        return (
            <button className="video-player-button not-selectable" onClick={() => this.props.startVideo()}>
                <div className="triangle"/>
            </button>
        );
    }
}

export default VideoPlayButton;